import React from 'react';
import { SearchResultsProvider } from './providers/SearchResultsProvider';
import { SearchResults } from './components/SearchResults';
import { FilteredSearchResultsProvider } from './providers/FilteredSearchResultsProvider';
import { MappableVenuesProvider } from './providers/MappableVenuesProvider';
import { SearchPageSeoMarkup } from './SearchPageSeoMarkup';

export const SearchResultsPage = () => {
  return (
    <SearchResultsProvider>
      <FilteredSearchResultsProvider>
        <MappableVenuesProvider>
          <SearchPageSeoMarkup />
          <SearchResults />
        </MappableVenuesProvider>
      </FilteredSearchResultsProvider>
    </SearchResultsProvider>
  );
};
